import React, { useMemo } from 'react';
import { useCanvasStore } from '@/stores/canvasStore';

function isDebugDragToBoardEnabled() {
  try {
    return new URLSearchParams(window.location.search).has('debugDragToBoard');
  } catch {
    return false;
  }
}

export function DragToBoardDebugButton() {
  const enabled = useMemo(() => isDebugDragToBoardEnabled(), []);
  const { items, moveItemsToBoard } = useCanvasStore();

  const firstMovableItem = items.find(i => i.item_type !== 'board_link');
  const firstBoardLink = items.find(i => i.item_type === 'board_link');
  const targetBoardId = (firstBoardLink?.content as { linked_board_id?: string } | null)?.linked_board_id;

  if (!enabled) return null;

  return (
    <button
      type="button"
      className="fixed top-4 left-4 z-50 rounded-md bg-destructive px-4 py-2 text-destructive-foreground shadow-lg"
      onClick={async () => {
        const testItemId = firstMovableItem?.id;
        const testBoardId = targetBoardId;

        alert(`Test move: Item ${testItemId} to Board ${testBoardId}`);

        if (!testItemId || !testBoardId) {
          alert('Missing item or board ID');
          return;
        }

        await moveItemsToBoard([testItemId], testBoardId);
      }}
    >
      TEST MOVE FIRST ITEM TO FIRST BOARD
    </button>
  );
}
